import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadAllStudentPaths } from './../../../../ng2/store/actions/student-paths-actions';
import {
  getAllStudentPathsLoadedStatus,
  getStudentPathsEntitiesList,
} from './../../../../ng2/store/selectors/student-paths-selector';

@Injectable()
export class StudentPathsResolver {
  resolveStudentPaths$(currentSchool, store): Promise<Observable<any>> {
    const payload = { schoolId: currentSchool._id };
    const studentPathsLoaded = getAllStudentPathsLoadedStatus;
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(studentPathsLoaded)
        .pipe(takeUntil(destroy$))
        .subscribe(allLoaded => {
          if (!allLoaded) store.dispatch(new LoadAllStudentPaths(payload));
          if (allLoaded) {
            const studentPaths$ = store.select(getStudentPathsEntitiesList);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(studentPaths$);
          }
        });
    });
  }
}
